import { atom } from 'jotai';
import { CurrencyIsoCode } from 'shared/data/wallets/v1';

export const convertCurrencyPopupState = atom<{
    isOpen: boolean;
    fromDefaultCurrency?: CurrencyIsoCode;
    toDefaultCurrency?: CurrencyIsoCode;
    // We have to pass a fallback `companyId` for a situations, when user from pages such as "Ready to pay"
    companyId?: string;
}>({
    isOpen: false,
});
